export default "__VITE_ASSET__D_sPyl3F__"